<ng-container>
	<div></div>
	<div style="margin-top: 8px; font-size: 15px; height: 75px; align-items: center">
		<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
			<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
				<div mat-line style="width:100%; display: flex;">
					<mat-form-field style="margin-left: 15px; margin-right: 15px; width:100%">
						<input matInput placeholder="Search Notes" #searchBox id="search-box" (keyup)="filterNotes(searchBox.value)" />
						@if (searchBox.value.length > 0) {
							<button mat-icon-button matSuffix aria-label="Clear" (click)="clearSearch()">
								<mat-icon>close</mat-icon>
							</button>
						}
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
			<div class="search-item-disclaimer" *ngIf="overMaxNoteLength$ | async">Showing top 200 results. Search to narrow list or export to see all notes.</div>
			<cdk-virtual-scroll-viewport itemSize="48" style="height:87%">
				<mat-action-list>
					<button mat-list-item *cdkVirtualFor="let note of notes$ | async" [ngClass]="{'sidenav-selected-item': isSelected(note), 'sidenav-row-item': !isSelected(note)}" (click)="selectNote(note)">
						<div matListItemIcon>
							<mat-icon class="sidenav-icon-avatar shared" *ngIf="!note.isPrivate">sticky_note_2</mat-icon>
							<mat-icon class="sidenav-icon-avatar private" *ngIf="note.isPrivate">sticky_note_2</mat-icon>
						</div>
						<div matListItemTitle> {{note.title}} </div>
						<div matListItemLine style="color:grey"> {{note.body}} </div>
						<mat-divider></mat-divider>
					</button>
				</mat-action-list>
			</cdk-virtual-scroll-viewport>
</ng-container>
